export enum CognitoException {
  UsernameExistsException = 'UsernameExistsException',
  InvalidPasswordException = 'InvalidPasswordException',
  InvalidParameterException = 'InvalidParameterException',
  UserNotConfirmedException = 'UserNotConfirmedException',
  UserLambdaValidationException = 'UserLambdaValidationException',
  PasswordResetRequiredException = 'PasswordResetRequiredException',
  CustomMessageTriggerException = 'CustomMessageTriggerException',
  NotAuthorizedException = 'NotAuthorizedException',
  ExpiredCodeException = 'ExpiredCodeException',
  LimitExceededException = 'LimitExceededException',
  UserNotFoundException = 'UserNotFoundException',
  InvalidPhoneNumber = 'Invalid phone number format',
  HatTrickSignUpException = 'PreSignUp failed with error Name, Surname, Birthday already exists',
  HatTrickFederatedSignUpException = 'Name, Surname, Birthday already exists in',
  CRMEmailExistedException = 'The email already exists on the CRM'
}

export interface AmplifyConfig {
  Auth: {
    authenticationFlowType: string | undefined;
    region: string | undefined;
    userPoolId: string | undefined;
    userPoolWebClientId: string | undefined;
  },
  oauth?: {
    domain: string | undefined;
    scope: [
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin'
    ],
    responseType: 'code',
    redirectSignIn: string | undefined;
    redirectSignOut: string | undefined;
    federationTarget: 'COGNITO_USER_POOLS'
  }
}
